export const passwordRequirements = [
    {
        test: /^(?=.{8,})/, message: "8-30 characters."
    },
    {
        test: /^(?=.*[a-z])/, message: "At least one lower cased letter."
    },
    {
        test: /^(?=.*[A-Z])/, message: "At least one upper cased letter."
    },
    {
        test: /^(?=.*[0-9])/, message: "At least one number."
    },
    {
        test: /^(?=.*[!@#\$%\^&\*])/, message: "At least one of the special character: ^$*!@#%&."
    },
    {
        test: /^(?!.*\s).*$/, message: "No space is allowed."
    },
]

export const validationMessage = {
    ENTER_EMAIL : "Please enter your email",
    ENTER_PASSWORD : "Please enter your password",
    ENTER_INVITE_CODE : "Please enter invite code",
    ENTER_VALID_EMAIL: "Please enter a valid email",
    INVITE_INVALID: "Invalid invite code",
    MISMATCH_INVITE_AND_EMAIL : "Email and invite code do not match",
    PASSWORD_CONFIRM : "Please confirm your password",
    PASSWORD_MISMATCH : "Confirm password does not match",
}

export const emailRegex = '^([a-z]|[A-Z]|[0-9]|[-_.@])*$'//'^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$';